import { RowCrudStatus } from "../../common/types";
import { UserNotification } from "../../../api/graphql";
import { LangStore } from "../../../store";

export type UserNotificationValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
};

export type UserNotificationErrorsType = {};

export function UserNotificationValuesInit(): UserNotificationValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
  };
}

export type UserNotificationType =
  | UserNotification
  | UserNotificationValuesType;

export function userNotificationDisplayId(
  source: Partial<UserNotification>,
  _langStore: LangStore
) {
  return source.title ?? _langStore.emptyStringSymbol;
}

export function getUserNotificationValues(
  source: UserNotificationType,
  _langStore: LangStore,
  _duplicated: boolean = false
): UserNotificationValuesType {
  const entityValues = UserNotificationValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : userNotificationDisplayId(source, _langStore);
  entityValues.version_ = source.version_;

  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
